import React from 'react';
import './pageLivreurNavbar.scss';
import './livreurNav.css';
import NotificationBell from '../../../components/topbar/NotificationBell';
import logoIcon from './../../../assets/logo doe.jpg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * Barre du haut du livreur — ALLÉGÉE (Phase A refonte navigation).
 * Ne garde que l'essentiel du haut (doc 05 : logo · notification · menu) :
 *   - logo → accueil,
 *   - UNE cloche (NotificationBell canonique) — la 2ᵉ cloche « à prendre » est
 *     retirée (son compteur + vibration passent sur l'onglet Livraisons de la
 *     barre basse),
 *   - bouton menu (avatar) → ouvre le tiroir « Plus » (ndoe:livreur-menu), qui
 *     porte désormais partage / dépenses / version / déconnexion.
 */
const PageLivreurNavbar = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);
  const initiale = (currentUser?.username || 'L').charAt(0).toUpperCase();

  return <div className="pageLivreurNavbar"><div className="pageLivreurNavbar-container"><nav><div className="navbar-wrapper">
    <div className="nav-logo"><img src={logoIcon} alt="Ndoé Boutique" className="nav-img" onClick={() => navigate('/')} /></div>
    <div className="navbar-right">
      <NotificationBell className="navbar-bell" />
      <button type="button" className="livnav-menu" aria-label="Ouvrir le menu"
        onClick={() => window.dispatchEvent(new Event('ndoe:livreur-menu'))}>{initiale}</button>
    </div>
  </div></nav></div></div>;
};

export default PageLivreurNavbar;
